import React, { createRef, useCallback, useEffect, useState } from "react";
import { StyleSheet, View, ScrollView, Text } from "react-native";
import { colors } from "src/assets";

import { Typography } from "src/components";

import LocalText from "src/local";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Dialog from "@mui/material/Dialog";

export type ActionDialogItem = {
  key: string;
  label: string;
};
export type ActionDialogProps = {
  open: boolean;
  items: Array<ActionDialogItem>;
  onAction: (index: number) => void;
  onClose: () => void;
};
export const ActionDialog: React.FC<ActionDialogProps> = ({
  open,
  items,
  onAction,
  onClose,
}) => {
  return (
    <Dialog onClose={onClose} fullWidth open={open}>
      <List>
        {items.map((item, index) => (
          <ListItem button onClick={() => onAction(index)} key={item.key}>
            <ListItemText
              primary={
                <Typography
                  containerStyle={{ justifyContent: "center" }}
                  textStyle={{
                    justifyContent: "center",
                    alignItems: "center",
                    color: colors.chokuRed,
                  }}
                  text={item.label}
                />
              }
            />
          </ListItem>
        ))}
        <ListItem
          autoFocus
          button
          centerRipple
          onClick={() => {
            onClose();
          }}
        >
          <ListItemText
            primary={
              <Typography
                containerStyle={{ justifyContent: "center" }}
                textStyle={{
                  justifyContent: "center",
                  alignItems: "center",
                  color: colors.chokuGray,
                }}
                text={LocalText.common.cancel}
              />
            }
          />
        </ListItem>
      </List>
    </Dialog>
  );
};
